import { Component } from '@angular/core';

/**
 * Newsletter panel (profile → Settings → Newsletter). Thin shell: a
 * vb-panel-header over the shared newsletter subscription card, which owns
 * the whole data flow — status fetch, the vb-dialog confirm, and the
 * subscribe/unsubscribe API calls.
 */
@Component({
    selector: 'vb-user-newsletter',
    templateUrl: './user-newsletter.component.html',
    styleUrls: ['./user-newsletter.component.scss'],
})
export class UserNewsletterComponent {}
